/**
 * useTheme Hook
 * Custom hook to access theme context
 */

import { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';

/**
 * Hook to access theme functionality
 * @returns {Object} Theme context value
 * - themeMode: Current mode (light/dark/system/auto)
 * - resolvedTheme: Actual applied theme (light/dark)
 * - isDark: Boolean indicating if dark theme is active
 * - setThemeMode: Function to set theme mode
 * - toggleTheme: Function to toggle between light/dark
 * - THEMES: Available theme modes constant
 */
export const useTheme = () => {
  const context = useContext(ThemeContext);

  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }

  return context;
};

export default useTheme;
